import Vue from "vue";

function initialLoad() {
  return {};
}

const state = initialLoad();

const actions = {
  async getCrmImportData(context, request) {
    let response = await Vue.http.get(`/cxm/CrmImportPostCheck/${request}`);

    if (response && response.data && response.data.Data) {
      return response.data.Data;
    }
    return null;
  },
  async getCrmImportCustomerReportData(context, request) {
    let response = await Vue.http.get(
      `/cxm/crmimportcontactpostcheckcsv/${request}`
    );
    if (response && response.data) {
      return response.data;
    }
    return null;
  },
  async getCRMImportReportExcelFile(context, request) {
    let response = await context.dispatch("processBlobRequest", {
      url: request.url,
      type: 'GET'
    });
    if (response && response.data) {
      return response.data;
    }
    return null;
  },
  async getCrmImportAutoMergeStatus(context, request) {
    let response = await Vue.http.get(`/cxm/AutoMergeStatus/${request}`);

    if (response && response.data && response.data.Data) {
      return response.data.Data;
    }
    return null;
  },
  async updateCrmImportAutoMergeStatus(context, request) {
    let response = await Vue.http.post(`/cxm/AutoMergeStatus`, request);

    if (response && response.data && response.data.Data) {
      return response.data.Data;
    }
    return null;
  }
};

const mutations = {};

const getters = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/CrmImport.js